import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-recommendation-card-details',
  templateUrl: './recommendation-card-details.component.html',
  styleUrls: ['./recommendation-card-details.component.scss'],
  standalone: false
})
export class AppRecommendationDetailsCardComponent implements OnChanges {
  @Input() data: any;
  groupedData: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      if (this.data && this.data.length) {
        this.groupedData = this.groupByPageName(this.data);
      } else {
        this.groupedData = [];
      }
    }
  }

  groupByPageName(data: any[]): any[] {
    const map = new Map<string, any>();
    for (const item of data) {
      if (!map.has(item.PageName)) {
        map.set(item.PageName, {
          PageName: item.PageName,
          FinalRemark: item.FinalRemark,
          CreatedBy: item.CreatedBy,
          CreatedOn: item.CreatedDate,
          positive: [],
          negative: []
        });
      }
      const group = map.get(item.PageName);
      if (item.Type === 'Positive') {
        group.positive.push(item.Value);
      } else if (item.Type === 'Negative') {
        group.negative.push(item.Value);
      }
    }
    return Array.from(map.values());
  }

  getMaxLen(group: any): number {
    return Math.max(group.positive.length, group.negative.length, 1);
  }
}
